import { render, staticRenderFns } from "./submitSuccessCard.vue?vue&type=template&id=e6a4b5ac&scoped=true"
import script from "./submitSuccessCard.vue?vue&type=script&lang=js"
export * from "./submitSuccessCard.vue?vue&type=script&lang=js"
import style0 from "./submitSuccessCard.vue?vue&type=style&index=0&id=e6a4b5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a4b5ac",
  null
  
)

export default component.exports